import * as React from 'react'

import ItemsListing from '../../../components/itemsListing'
import createSearchResultBodyContainer, {
  Props
} from '../../../containers/searchResultBodyContainer'

const SearchResultBody: React.SFC<Props> = ({
  matches,
  currentSite,
  viewType,
  location,
  showSingleRow
}) => (
  <ItemsListing
    items={matches}
    location={location}
    currentSite={currentSite}
    viewType={viewType}
    showSingleRow={showSingleRow}
  />
)

export default createSearchResultBodyContainer(SearchResultBody)
